import Bus from "@/lib/Bus";

import { IUser } from "server/src/user/IUser";
import { ICtx, ctxType } from "server/src/ai/interface/ICtx";
const bus: Bus = new Bus().getBus();

export class CtxStore {

  static async save(ctx:any) {
    const ctx_with_id: ICtx | undefined = await bus.api("/api/ai/ctx/save", { obj: ctx });
    return ctx_with_id
  }


  static async get(parent_id: string | undefined, user?:IUser) {
    const ctx = await bus.api("/api/ai/folder/getCtx", {obj: { parent_id: parent_id, user:user}});
    return ctx
  }

}





